import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import * as Sentry from '@sentry/react';
import './index.css';
import App from './App';

const isSentryEnvironment = import.meta.env.MODE === 'uat' || import.meta.env.MODE === 'production';
const sentryDsn =
  import.meta.env.VITE_ADMIN_SENTRY_DSN ||
  import.meta.env.VITE_SENTRY_DSN ||
  (isSentryEnvironment
    ? 'https://5a7ba9ab6f4f01e88caccc05081393a9@o4511217093509120.ingest.de.sentry.io/4511355409793104'
    : '');

const canonicalHost = import.meta.env.VITE_ADMIN_CANONICAL_HOST || 'admindash.workbill.in';

if (
  typeof window !== 'undefined' &&
  import.meta.env.PROD &&
  canonicalHost &&
  window.location.hostname !== canonicalHost
) {
  const isFirebaseHost = (host) => host.endsWith('.web.app') || host.endsWith('.firebaseapp.com');
  const isFirebaseAuthPath = window.location.pathname.startsWith('/__/auth/');

  if (!isFirebaseAuthPath && isFirebaseHost(window.location.hostname)) {
    const nextUrl = `${window.location.protocol}//${canonicalHost}${window.location.pathname}${window.location.search}${window.location.hash}`;
    window.location.replace(nextUrl);
  }
}

if (sentryDsn) {
  Sentry.init({
    dsn: sentryDsn,
    environment: import.meta.env.MODE,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration({ maskAllText: true, blockAllMedia: true }),
    ],
    tracesSampleRate: import.meta.env.MODE === 'production' ? 0.2 : 1.0,
    replaysOnErrorSampleRate: 1.0,
  });
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<div role="alert">Something went wrong. Reload to continue.</div>}>
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>
);
